import {Lightbox} from '../../classes/Lightbox';
import {pluralNumber} from '../../../utils/numerals/pluralNumber';

export const initBird = () => {
	const birds = document.querySelectorAll( 'section.cds2-complex-layout' );

	if ( !birds.length )
	{
		return;
	}

	Array.from( birds ).forEach( ( bird ) => {
		const birdImage = bird.querySelector( 'image' );
	
		if ( birdImage )
		{
			const image = new Image();

			image.src = birdImage.getAttribute( 'xlink:href' );

			image.addEventListener( 'load', () => {
				bird.classList.add( 'ready' );
			} );
		}

		const birdsSVG = Array.from( bird.querySelectorAll( 'svg' ) );

		birdsSVG.forEach( ( it, i ) => {
			it.id = `bird_to_switch_${i + 1}`;

			if ( !it.hasAttribute( 'preserveAspectRatio' ) )
			{
				it.setAttribute( 'preserveAspectRatio', 'xMidYMid slice' );
			}
		} );

		const isParking = bird.classList.contains( 'parking' );
		const abbr = isParking ? 'PRK-' : 'BLD-';
		const buildings = Array.from( bird.querySelectorAll( `[id*="${abbr}"]` ) );
		const descriptionPlaces = Array.from( bird.querySelectorAll( '[id^="DESC-"]' ) );
		const tooltip = bird.querySelector( 'div.tooltip' );
		const labelsList = bird.querySelector( 'ul.labels' );
		const birdJSON = JSON.parse( bird.querySelector( 'figure' ).dataset.json );
		let componentRect = bird.getBoundingClientRect();
		let windowWidth = window.innerWidth;

		const fillTooltip = ( buildingInfo ) => {
			tooltip.querySelector( 'h3' ).innerHTML = buildingInfo.nameBuilding;

			if ( buildingInfo.queues )
			{
				tooltip.querySelector( 'h3' ).insertAdjacentHTML( 'beforeend', ` <span>${buildingInfo.queues}</span>` );
			}
			
			const paragraph = tooltip.querySelector( 'p' );

			if ( paragraph )
			{
				let paragraphContent = '';

				if ( isParking )
				{
					paragraphContent = buildingInfo.places;
				}
				else if ( buildingInfo.aptCount > 0 )
				{
					let minAptPrice = 0;
					if ( typeof buildingInfo.minPrice === 'string' )
					{
						let minAptPriceString = buildingInfo.minPrice;
						minAptPriceString = minAptPriceString.replaceAll( / /ug, '' );
						minAptPrice = parseInt( minAptPriceString, 10 );
					}
					else if ( typeof buildingInfo.minPrice === 'number' )
					{
						minAptPrice = buildingInfo.minPrice;
					}
					
					if ( minAptPrice > 0 )
					{
						paragraphContent = `Квартиры от&nbsp;${buildingInfo.minPrice}`;
					}
				}
				else if ( buildingInfo.description )
				{
					paragraphContent = buildingInfo.description;
				}
				else
				{
					paragraphContent = 'Все квартиры проданы';
				}
				
				paragraph.innerHTML = paragraphContent;
			}

			let status = '';

			switch ( buildingInfo.constructionState )
			{
			case 'finished':
				status = 'Корпус сдан';

				break;
			case 'zos':
				status = 'Получен ЗОС';

				break;
			case 'preparation':
				status = 'Подготовка к&nbsp;вводу';

				break;
			case 'state-comission ':
				status = 'Проводится госкомиссия';

				break;
			default:
				status = `Сдача&nbsp;— ${buildingInfo.deadlineRaw}`;
			}

			if ( buildingInfo.type === 'complex' )
			{
				const progressPercent = Math.round( buildingInfo.construcionProgressPercent );
				
				tooltip.querySelector( 'div.deadline' ).dataset.progress = progressPercent === 0 || progressPercent === 100 ? 'no' : 'yes';
				tooltip.querySelector( 'div.deadline' ).innerHTML = progressPercent === 0 || progressPercent === 100 ? status : `<span class="range" style="width: ${progressPercent}%;"></span><span>${buildingInfo.constructionState === 'finished' ? 'Сдан' : `${buildingInfo.deadlineRaw}`}</span> <span>${progressPercent}%</span>`;
				tooltip.querySelector( 'div.deadline' ).style.display = buildingInfo.aptCount > 0 ? '' : 'none';
				tooltip.querySelector( 'a' ).style.display = buildingInfo.aptCount > 0 || isParking ? '' : 'none';
				tooltip.querySelector( 'a' ).innerHTML = isParking ? `от ${buildingInfo.minPrice}` : `Показать ${buildingInfo.aptCount}&nbsp;${pluralNumber( buildingInfo.aptCount, 'квартиру', 'квартиры', 'квартир' )}`;
			}

			const tooltipLink = tooltip.querySelector( 'a' );
			if ( buildingInfo.aptCount && Number(buildingInfo.aptCount) <= 15 ) {
				tooltipLink.href = `/choose/apartments/?filter[checkbox][complexes][${bird.dataset.guid_complex}]&filter[checkbox][buildings][${buildingInfo.guid}]`;
			} else {
				tooltipLink.href = buildingInfo.uri;
			}
		};
		
		buildings.forEach( ( it ) => {
			const guid = it.id.replace( abbr, '' );
			const buildingInfo = birdJSON.find( ( building ) => building.guid === guid );
			let label = '';
			let labelToActivate = null;

			const labelCircles = it.querySelectorAll( '[id*="Label"] :first-child' );

			if ( !labelCircles.length )
			{
				it.classList.add( 'inactive' );
				
				return;
			}

			Array.from( labelCircles ).forEach( ( labelCircle, i ) => {
				const labelText = labelCircle.closest( '[id*="Label"]' ).querySelector( 'text' );
				const labelRect = labelCircle.getBoundingClientRect();

				label = document.createElement( 'li' );
				label.id = `LBL-${labelText.innerHTML}`;
				label.innerHTML = labelText.innerHTML;
				label.style.top = `${labelRect.y + ( labelRect.width / 2 ) - componentRect.y}px`;
				label.style.left = `${labelRect.x + ( labelRect.height / 2 ) - componentRect.x}px`;
				labelsList.append( label );

				if ( !buildingInfo )
				{
					label.classList.add( 'inactive' );
				}

				if ( i === 0 )
				{
					labelToActivate = label;
				}
			} );

			if ( !buildingInfo )
			{
				it.classList.add( 'inactive' );
				
				return;
			}
			
			it.addEventListener( 'mouseenter', () => {
				if ( document.body.classList.contains( 'is-touch' ) || window.innerWidth < 1024 )
				{
					return;
				}
				
				if ( bird.querySelector( `#BLD-${tooltip.dataset.guid}` ) )
				{
					bird.querySelector( `#BLD-${tooltip.dataset.guid}` ).classList.remove( 'hovered' );
					tooltip.dataset.guid = '';
				}

				if ( bird.querySelector( 'li.active' ) )
				{
					bird.querySelector( 'li.active' ).classList.remove( 'active' );
				}

				fillTooltip( buildingInfo );
				
				const labelRect = it.querySelector( '[id*="Label"] :first-child' ).getBoundingClientRect();
				
				componentRect = bird.getBoundingClientRect();

				const top = labelRect.y + ( labelRect.width / 2 ) - componentRect.y;
				let left = labelRect.x + ( labelRect.height / 2 ) - componentRect.x;

				labelToActivate.classList.add( 'active' );
				tooltip.style.top = `${top}px`;
				tooltip.style.left = `${left}px`;

				const tooltipRect = tooltip.getBoundingClientRect();

				if ( tooltipRect.x < 16 )
				{
					left += tooltipRect.width;
					tooltip.style.left = `${left}px`;
				}

				tooltip.classList.add( 'show' );
				tooltip.dataset.guid = guid;
			} );

			it.addEventListener( 'mouseleave', () => {
				if ( window.innerWidth < 1024 )
				{
					return;
				}
				
				tooltip.classList.remove( 'show' );
			} );

			it.addEventListener( 'click', ( evt ) => {
				evt.preventDefault();

				if ( document.body.classList.contains( 'is-touch' ) || window.innerWidth < 1024 )
				{
					const lightboxContent = document.createElement( 'div' );
					
					fillTooltip( buildingInfo );
					lightboxContent.classList.add( 'bird-tooltip' );
					lightboxContent.innerHTML = tooltip.innerHTML;
					Lightbox.open( lightboxContent, null, 'tooltip' );
				}
				else
				{
					if ( buildingInfo.aptCount && Number(buildingInfo.aptCount) <= 15 ) {
						location.href = `/choose/apartments/?filter[checkbox][complexes][${bird.dataset.guid_complex}]&filter[checkbox][buildings][${buildingInfo.guid}]`;
					} else {
						location.href = birdJSON.length > 1 ? buildingInfo.uri : buildingInfo.uri.split( '?' )[0];
					}
				}
			} );

			tooltip.addEventListener( 'mouseenter', () => {
				if ( bird.querySelector( `#BLD-${tooltip.dataset.guid}` ) )
				{
					bird.querySelector( `#BLD-${tooltip.dataset.guid}` ).classList.add( 'hovered' );
				}
			} );

			tooltip.addEventListener( 'mouseleave', () => {
				if ( bird.querySelector( `#BLD-${tooltip.dataset.guid}` ) )
				{
					bird.querySelector( `#BLD-${tooltip.dataset.guid}` ).classList.remove( 'hovered' );
				}
			} );
		} );

		descriptionPlaces.forEach( ( it ) => {
			const placeRect = it.getBoundingClientRect();
			const description = bird.querySelector( `li#infrastructure-${it.id}` );

			if ( !description )
			{
				return;
			}

			description.style.top = `${placeRect.y + ( placeRect.width / 2 ) - componentRect.y}px`;
			description.style.left = `${placeRect.x + ( placeRect.height / 2 ) - componentRect.x}px`;
		} );

		bird.querySelector( 'div.bird' ).scrollLeft = window.innerWidth < 1024 ? window.innerHeight * ( 1920 / 1080 ) * 0.15 : 0;

		const tip = bird.querySelector( 'div.tip' );
		let tipRead = false;
		let scrollTimeout = null;

		const hideTip = () => {
			tip.classList.add( 'hide' );
			tipRead = true;
			bird.querySelector( 'div.bird' ).removeEventListener( 'scroll', hideTip );
		};
		
		const handleTip = () => {
			if ( tipRead )
			{
				return;
			}

			if ( window.innerWidth < 1024 )
			{
				tip.classList.remove( 'hide' );

				scrollTimeout = setTimeout( () => {
					bird.querySelector( 'div.bird' ).addEventListener( 'scroll', hideTip );
					clearTimeout( scrollTimeout );
				}, 100 );
			}
			else
			{
				tip.classList.add( 'hide' );
				bird.querySelector( 'div.bird' ).removeEventListener( 'scroll', hideTip );
				clearTimeout( scrollTimeout );
			}
		};
		
		handleTip();

		bird.addEventListener( 'change', ( evt ) => {
			if ( !/infr_items/u.test( evt.target.name ) )
			{
				return;
			}

			if ( evt.target.checked )
			{
				Array.from( bird.querySelectorAll( 'input[name*="infr_items"]' ) ).forEach( ( it ) => {
					if ( it !== evt.target )
					{
						it.checked = false;
					}
				} );
			}
		} );

		window.addEventListener( 'resize', () => {
			if ( windowWidth === window.innerWidth )
			{
				return;
			}

			windowWidth = window.innerWidth;
			componentRect = bird.getBoundingClientRect();
			
			buildings.forEach( ( it ) => {
				const guid = it.id.replace( abbr, '' );
				const buildingInfo = birdJSON.find( ( building ) => building.guid === guid );

				if ( !buildingInfo )
				{
					return;
				}

				const labelSelector = `li[id="LBL-${buildingInfo.nameBuilding.replace( 'Корпус ', '' ).replace( 'Участок ', '' ).replace( '*', '' ).trim()}"]`;
				const label = labelsList.querySelector( labelSelector );
				const labelRect = it.querySelector( '[id*="Label"] circle' ).getBoundingClientRect();
				
				if ( label )
				{
					label.style.top = `${labelRect.y + ( labelRect.width / 2 ) - componentRect.y}px`;
					label.style.left = `${labelRect.x + ( labelRect.height / 2 ) - componentRect.x}px`;
				}
			} );

			descriptionPlaces.forEach( ( it ) => {
				const placeRect = it.getBoundingClientRect();
				const description = bird.querySelector( `li#infrastructure-${it.id}` );

				if ( !description )
				{
					return;
				}
		
				description.style.top = `${placeRect.y + ( placeRect.width / 2 ) - componentRect.y}px`;
				description.style.left = `${placeRect.x + ( placeRect.height / 2 ) - componentRect.x}px`;
			} );

			bird.querySelector( 'div.bird' ).scrollLeft = 0;
			handleTip();
		} );
	} );
};
